<template>
  <el-table 
    class="my-table-hok_v1" 
    size="mini" 
    :data="tableData" 
    :header-cell-style="{
      background: 'rgb(35, 36, 72)',
      color: 'rgb(188, 189, 212)',
      'font-size': '14px',
      'font-family': 'Microsoft YaHei, Microsoft YaHei-Regular',
      'font-weight': 'normal'
    }"
    :span-method="cellMerge"
    :fit="false">
    <el-table-column prop="model" label="机型" width="100"></el-table-column>
    <el-table-column prop="quality" label="画质" width="80"></el-table-column>
    <el-table-column label="版本日期" width="140">
      <template #default="scope">
        <span
          :style="
            'margin-left:' +
            (scope.row?.data.level == 0 ? '0px' : '10px')
          "
        >
          {{ scope.row.data?.date
          }}<i
            style="cursor: pointer"
            v-if="scope.row?.data?.level == 0 && scope.row.show"
            @click="expandCheck(scope.row)"
            :class="
              scope.row.check
                ? 'el-icon-arrow-down'
                : 'el-icon-arrow-up'
            "
          ></i>
        </span>
        <span
          @click="expandCheckAdd(scope.row)"
          style="color: #70c1f1; cursor: pointer"
          v-if="scope.row.many"
          >(查看更多)</span
        >
      </template>
    </el-table-column>
    <el-table-column prop="branch" label="分支" width="90"></el-table-column>
    <el-table-column prop="svn" label="SVN" width="80">
      <template #default="{row}">{{ row.svn || '--' }}</template>
    </el-table-column>
    <el-table-column label="结论" width="70">
      <template #default="{ row }">
        <span :style="{color: getResultColor(row)}">{{ row.result }}</span>
      </template>
    </el-table-column>

    <!-- 指标列（标准/数值） -->
    <el-table-column
      v-for="metric in metricColumns"
      :key="metric.label"
      :label="metric.label"
    >
      <el-table-column min-width="120">
        <template #header>
          <div>标准</div>
        </template>
        <template #default="{row}">
          <span style="color: rgb(51, 157, 255);">{{ row.standard[metric.key] || '/' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="数值" width="60">
        <template #default="{row}">
          <span :style="{color: getValueColor(row, metric.key)}">{{ row?.[metric.key] ?? '--' }}</span>
        </template>
      </el-table-column>
    </el-table-column>

    <el-table-column label="内存峰值" prop="peak_memory_swap" width="160">
      <template #header>
        <div>内存峰值</div>
        <div>（Memory+Swap）</div>
      </template>
      <template #default="scope">
        <span>{{ scope.row.peak_memory_swap }}</span>
      </template>
    </el-table-column>

    <el-table-column label="链接">
      <template #default="scope">
        <span>
          <a
            target="_blank"
            style="cursor: pointer; color: rgb(24, 144, 255);text-decoration: none"
            :href="scope.row.url"
            >查看</a>
        </span>
      </template>
    </el-table-column>

    <el-table-column label="PerfDog" width="80">
      <template #default="{ row }">
        <a
          v-if="row.perfdogUrl"
          target="_blank"
          style="cursor: pointer; color: rgb(24, 144, 255); text-decoration: none"
          :href="row.perfdogUrl"
        >{{ row.perfdogText || '对比链接' }}</a>
        <span v-else>--</span>
      </template>
    </el-table-column>

    <el-table-column label="SVN链接" width="90">
      <template #default="{ row }">
        <a
          v-if="row.svnUrl && row.svnUrl !== '--'"
          target="_blank"
          style="cursor: pointer; color: rgb(24, 144, 255); text-decoration: none"
          :href="row.svnUrl"
        >SVN链接</a>
        <span v-else>--</span>
      </template>
    </el-table-column>

    <el-table-column label="adb报错" #default="{row}" align="center">
      {{ getAdbCount(row) }}
    </el-table-column>

    <el-table-column label="adb下载" #default="{row}" align="center">
      <a v-if="row?.adb?.filepath" :href="row?.adb?.filepath" target="_blank" download style="color: rgb(24, 144, 255);text-decoration: none">日志文件</a>
      <span v-else>-</span>
    </el-table-column>

    <el-table-column label="删除" #default="{row}">
      <el-button type="text" size="mini" @click="deleteRow(row)">删除</el-button>
    </el-table-column>
  </el-table>
</template>

<script>
import axios from 'axios'
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  name: 'PosterTable',
  props: {
    project: {
      type: [String, Number],
      default: 57,
    },
    skinId: {
      type: [String, Number],
      default: '',
    },
    // 海报主数据请求地址
    posterUrl: {
      type: String,
      default: '/report/poster_data_v2/',
    },
    // 「查看更多」分页数据请求地址
    posterMoreUrl: {
      type: String,
      default: '/report/poster_data_more_v1/',
    },
    // 业务类型（透传到请求参数）
    type: {
      type: [String, Number],
      default: '',
    },
    metricColumns: {
      type: Array,
    }
  },

  data() {
    return {
      tableData: [],
      posterRes: {}, // 原始数据，按机型存储
      localProject: 57,
      fetchCount: 0,
    }
  },

  watch: {
    skinId() {
      if (!this.fetchCount) {
        this.fetchData()
        this.fetchCount++
      }
    },
  },

  methods: {
    async deleteRow(row) {
      try {
        await ElMessageBox.confirm(
          '确定要删除该条记录吗？',
          '删除确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
      } catch (e) {
        return
      }
      await axios.put(`performance/skin_performance/`, {
        "id_test": row.id_test,
        "is_valid": false,
        "project": this.localProject,
      })
      ElMessage.success('删除成功')
      this.fetchData()
    },

    getAdbCount(row) {
      const count = row?.adb?.error_count
      return (count || count === 0) ? count : '-'
    },

    isEmpty(val) {
      return val === null || val === undefined
    },

    getChangeVal(row, metric) {
      return row?.standard?.[metric.key]?.change
    },

    getChangeAbs(row, metric) {
      const change = row?.standard?.[metric.key]?.change
      if (change !== null && change !== undefined) {
        return Math.abs(change)
      }
    },

    async fetchData() {
      if (!this.skinId) return
      try {
        this.tableData = []
        const { data } = await axios(this.posterUrl, {
          params: {
            project: this.project,
            skin_id: this.skinId,
          }
        })
        this.posterRes = {}

        for (const model in data) {
          let entries = Array.isArray(data[model]) ? data[model] : []
          const show = entries.length > 1
          this.posterRes[model] = entries
          entries.forEach((v) => {
            if (v.level == 0) {
              this.tableData.push(this.buildRow(model, v, show))
            }
          })
        }
        this.recomputeMany()
      } catch (e) {
        console.error('poster_data_v2 请求失败', e)
        ElMessage.error('海报数据获取失败')
      }
    },

    buildRow(model, v, show) {
      return {
        ...v,
        model,
        quality: v.quality || '',
        data: { date: v.date, level: v.level },
        show: !!show,
        check: true,
        many: false,
        branch: v.custom_version || '--',
        perfdogUrl: v.link || '',
        perfdogText: v.link ? '查看' : '',
        svnUrl: v['svn链接'] || '',
      }
    },

    // 合并单元格（按机型）
    cellMerge({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 0) return

      const model = row.model
      const rows = this.tableData
      let startIdx = -1
      let count = 0

      for (let i = 0; i < rows.length; i++) {
        if (rows[i].model === model) {
          if (startIdx === -1) startIdx = i
          count++
        }
      }

      if (rowIndex === startIdx && count > 1) {
        return { rowspan: count, colspan: 1 }
      } else if (count > 1) {
        return { rowspan: 0, colspan: 0 }
      }
    },

    // 展开/收起同一日期下的子版本（level 0 / level 1）
    expandCheck(data) {
      data.check = !data.check
      const model = data.model
      if (!data.check) {
        const addData = this.posterRes[model].filter(
          (v) => v.level != 0
        )
        const list = addData.map((v) =>
          this.buildRow(model, v, false)
        )
        const index = this.tableData.findIndex(
          (r) =>
            r.model == model &&
            r.data.date == data.data.date
        )
        if (index !== -1) {
          this.tableData.splice(index + 1, 0, ...list)
        }
      } else {
        this.tableData = this.tableData.filter(
          (r) =>
            !(
              r.model === model &&
              r.data.level === 1
            )
        )
      }
      this.recomputeMany()
    },

    // 日期列「查看更多」——调用 posterMoreUrl
    async expandCheckAdd(data) {
      const model = data.model
      const page = this.tableData.filter((r) => r.model == model).length
      try {
        const { data: moreData } = await axios(this.posterMoreUrl, {
          params: {
            project: this.project,
            skin_id: this.skinId,
            device_name: model,
            page,
          },
        })

        if (moreData && moreData.length > 0) {
          const list = []
          moreData.forEach((v) => {
            this.posterRes[model].push(v)
            list.push(this.buildRow(model, v, false))
          })
          this.insertAfterLastOccurrenceAdd(model, list)
          this.recomputeMany()
        } else {
          ElMessage.error('暂无更多数据')
        }
      } catch (e) {
        console.error('poster_data_more_v1 请求失败', e)
        ElMessage.error('查看更多数据获取失败')
      }
    },

    insertAfterLastOccurrenceAdd(model, newDevice) {
      let lastIndex = -1
      this.tableData.forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index
        }
      })
      if (lastIndex !== -1) {
        this.tableData.splice(lastIndex + 1, 0, ...newDevice)
      } else {
        this.tableData.push(...newDevice)
      }
    },

    // 重新计算每个机型分组的最后一行，标记「查看更多」
    recomputeMany() {
      const occurrenceCount = {}
      const lastOccurrence = {}
      this.tableData.forEach((device, index) => {
        let key = `${device.model}`;

        if (!occurrenceCount[key]) occurrenceCount[key] = 0
        occurrenceCount[key]++
        lastOccurrence[key] = index
      })
      this.tableData.forEach((device, index) => {
        let key = `${device.model}`;
        if (occurrenceCount[key] > 1) {
          device.many = index === lastOccurrence[key];
        } else {
          device.many = false;
        }
      })
    },

    getResultColor(row) {
      const result = row.result
      if (result == '达标') {
        return 'rgb(121, 217, 127)'
      } else if (result == '不达标') {
        return 'rgb(255, 76, 55)'
      }
    },

    getValueColor(row, item) {
      const color = row?.color?.[item]

      if (color == 'green') {
        return 'rgb(121, 217, 127)'
      } else if (color == 'red') {
        return 'rgb(255, 76, 55)'
      } else {
        return ''
      }
    },
  },

}
</script>

<style scoped>
.el-table {
  --el-bg-color: transparent;
}

.el-table :deep(th),
.el-table :deep(tr),
.el-table :deep(td),
.el-table :deep(tr:hover),
.el-table :deep(tr:hover td) {
  color: #fff;
  background-color: rgb(34, 37, 41);
  border-bottom: 1px solid #606469;
}

.el-table :deep(tr:hover td) {
  color: #4ed8da;
}

.my-table-hok_v1 :deep(.el-table__row .cell) {
  background: rgb(35, 36, 72);
  color: rgb(188, 189, 212);
  font-size: 14px;
  font-family: "Microsoft YaHei", "Microsoft YaHei-Regular";
}

.el-table :deep(.el-table__body-wrapper) {
  background-color: rgb(34, 37, 41);
}
</style>
